const MESSAGES = {
  ja: {
    name: "お名前を入力してください",
    email: "有効なメールアドレスを入力してください",
    message: "メッセージは10文字以上で入力してください",
    sending: "送信中…",
    ok: "送信を受け付けました。内容を確認のうえ、ご連絡いたします。",
    bad: "送信に失敗しました。メールでお送りください：",
    mailLink: "メールで送信する",
  },
  en: {
    name: "Please enter your name",
    email: "Please enter a valid email address",
    message: "Message must be at least 10 characters",
    sending: "Sending…",
    ok: "Thank you. We have received your message and will follow up shortly.",
    bad: "Couldn't send. Please email us instead:",
    mailLink: "Send via email",
  },
};

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function lang() {
  return document.documentElement.lang === "en" ? "en" : "ja";
}

function mailtoLink(payload) {
  return `mailto:hello@lixoris.com?subject=${encodeURIComponent(
    `Inquiry from ${payload.name} — lixoris.com`,
  )}&body=${encodeURIComponent(
    `Name: ${payload.name}\nEmail: ${payload.email}\nCompany: ${payload.company || "-"}\n\n${payload.message}`,
  )}`;
}

export function initContactForm() {
  const form = document.getElementById("contact-form");
  if (!form) return;
  const status = document.getElementById("form-status");
  const submit = document.getElementById("cf-submit");
  if (!status || !submit) return;

  const fieldOf = (name) => form.querySelector(`[name="${name}"]`)?.closest(".field") ?? null;

  function setError(name, message) {
    const field = fieldOf(name);
    if (!field) return;
    field.classList.toggle("invalid", !!message);
    const err = field.querySelector(".err");
    if (err) err.textContent = message ?? "";
  }

  function validate(payload) {
    const t = MESSAGES[lang()];
    let ok = true;
    if (payload.name.trim().length < 2) {
      setError("name", t.name);
      ok = false;
    } else setError("name", null);
    if (!EMAIL_RE.test(payload.email.trim())) {
      setError("email", t.email);
      ok = false;
    } else setError("email", null);
    if (payload.message.trim().length < 10) {
      setError("message", t.message);
      ok = false;
    } else setError("message", null);
    return ok;
  }

  function showFallback(payload) {
    const t = MESSAGES[lang()];
    status.className = "form-status bad";
    status.innerHTML = `${t.bad} <a href="${mailtoLink(payload)}">${t.mailLink}</a>`;
  }

  form.addEventListener("submit", async (event) => {
    event.preventDefault();
    const fd = new FormData(form);
    const payload = {
      name: String(fd.get("name") ?? ""),
      email: String(fd.get("email") ?? ""),
      company: String(fd.get("company") ?? ""),
      message: String(fd.get("message") ?? ""),
      company_website: String(fd.get("company_website") ?? ""),
    };

    status.className = "form-status";
    status.textContent = "";
    if (!validate(payload)) return;

    const t = MESSAGES[lang()];
    submit.disabled = true;
    status.textContent = t.sending;

    try {
      const res = await fetch("/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      if (res.ok) {
        status.className = "form-status ok";
        status.textContent = t.ok;
        form.reset();
      } else {
        const data = await res.json().catch(() => ({}));
        if (res.status === 400 && data.errors) {
          Object.keys(data.errors).forEach((key) => {
            setError(key, MESSAGES[lang()][key] ?? "Invalid");
          });
          status.textContent = "";
        } else {
          showFallback(payload);
        }
      }
    } catch {
      showFallback(payload);
    } finally {
      submit.disabled = false;
    }
  });
}
